import { LoggerService } from './LoggerService';

export const initGlobalErrorHandlers = () => {
  // Catch unhandled runtime errors
  window.addEventListener('error', (event) => {
    LoggerService.error('Unhandled runtime error', {
      error: event.error?.message || event.message,
      stack: event.error?.stack,
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
    });
  });

  // Catch unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    LoggerService.error('Unhandled promise rejection', {
      error: event.reason?.message || String(event.reason),
      stack: event.reason?.stack,
    });
  });
};
